<script>
  import { onDestroy } from 'svelte';

  export let isLocked = false;

  let body;
  let overflowY;
  let position;
  let width;
  if (typeof window !== 'undefined') {
    body = document.body;

    overflowY = body.style.overflowY;
    position = body.style.position;
    width = body.style.width;
  }

  $: if (isLocked) {
    lock();
  } else {
    unlock();
  }

  if (typeof window !== 'undefined') {
    onDestroy(unlock);
  }

  function lock() {
    if (typeof window !== 'undefined') {
      overflowY = body.style.overflowY;
      position = body.style.position;
      width = body.style.width;

      body.style.overflowY = 'scroll';
      body.style.position = 'fixed';
      body.style.width = '100%';
    }
  }

  function unlock() {
    if (typeof window !== 'undefined') {
      body.style.overflowY = overflowY;
      body.style.position = position;
      body.style.width = width;
    }
  }
</script>
